"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textPropsToFilter = exports.defaultProps = exports.DEFAULT_LINE_HEIGHT = exports.DEFAULT_FONT_SIZE = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
const defaultProps = exports.defaultProps = {
  font: 'primary',
  hyphens: 'none'
};
const DEFAULT_FONT_SIZE = exports.DEFAULT_FONT_SIZE = (0, _utils.token)('text.size.200');
const DEFAULT_LINE_HEIGHT = exports.DEFAULT_LINE_HEIGHT = (0, _utils.token)('text.lineHeight.200');
const textPropsToFilter = exports.textPropsToFilter = ['backgroundColor', 'color', 'display', 'font', 'fontSize', 'fontStyle', 'fontWeight', 'hyphens', 'isInMobileLayout', 'lineHeight', 'margin', 'shouldUseFixedFontStyle', 'textAlign', 'textDecoration', 'wordBreak', 'variant'];